import React, { FC, useState } from "react";
import "./RequestModal.css";
import Modal from "../Modal";
import { useNavigate } from "react-router-dom";

interface RequestModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: string[];
  setSelectionState: (val: string) => void;
}

const PROBLEM_LEVELS = [
  "Низкий",
  "Средний",
  "Стандартный",
  "Высокий",
  "Критичный"
];

const getCurrentDate = () => {
  const date = new Date();
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
};

export const RequestModal: FC<RequestModalProps> = ({
  isOpen,
  onClose,
  data,
  setSelectionState
}) => {
  const [staffName, setStaffName] = useState("");
  const [staffEmail, setStaffEmail] = useState("");
  const [problems, setProblems] = useState("");
  const [problemLevel, setProblemLevel] = useState("Стандартный");
  const [isSending, setIsSending] = useState(false);

  const handleClose = () => {
    setStaffName("");
    setStaffEmail("");
    setProblems("");
    setProblemLevel("Стандартный");
    setIsSending(false);
    onClose();
  };

  const sendData = () => {
    if (isSending) return; // Предотвращаем повторную отправку
    setIsSending(true);

    const userName = sessionStorage.getItem("userName");

    const requestData = {
      action: "CREATE_APPEAL",
      user_name: userName,
      serial_number: data[2],
      product_number: "",
      product: data[1],
      supp_number: data[0],
      put_address: data[5],
      problem_description: problems,
      problem_lvl: problemLevel,
      critical_rate: data[6],
      file_link: "",
      date: getCurrentDate(), 
      employee: staffName,
      employee_email: staffEmail,
      support_start_date: data[3],
      support_end_date: data[4],
      status: "В очереди",
    };

    if (window.ws && window.ws.readyState === WebSocket.OPEN) {
      window.ws.send(JSON.stringify(requestData));
      window.ws.onmessage = (event: { data: string; }) => {
        handleClose();
        setSelectionState('requests')
    }
    

    } else {
      console.error("Ошибка соединения с сервером");
      setIsSending(false);
    }
  };

  return (
    <Modal show={isOpen} onClose={handleClose}>
      <div className="request-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h2>Создать обращение</h2>
            <button onClick={handleClose} className="close-button">
              ×
            </button>
          </div>
          <div className="modal-body">
            <div className="modal-body-list">
              {data.length > 0 && data.map((item, index) => (
                <span key={index}>{item}</span>
              ))}
            </div>
            <br />
            <br />
            <div className="input-group">
              <span>Сотрудник</span>
              <input
                type="text"
                value={staffName}
                onChange={(e) => setStaffName(e.target.value)}
                disabled={isSending}
              />
            </div>
            <div className="input-group">
              <span>Email сотрудника</span>
              <input
                type="text"
                value={staffEmail}
                onChange={(e) => setStaffEmail(e.target.value)}
                disabled={isSending}
              />
            </div>
            <div className="input-group">
              <span>Описание проблемы</span>
              <input
                type="text"
                value={problems}
                onChange={(e) => setProblems(e.target.value)}
                disabled={isSending}
              />
            </div>
            <div className="input-group">
              <span>Уровень критичности</span>
              <select
                value={problemLevel}
                onChange={(e) => setProblemLevel(e.target.value)}
                className="problem-level-select"
                disabled={isSending}
              >
                {PROBLEM_LEVELS.map((level) => (
                  <option key={level} value={level}>
                    {level}
                  </option>
                ))}
              </select>
            </div>
            <button 
              onClick={sendData} 
              disabled={isSending}
              className={isSending ? 'sending-button' : ''}
            >
              {isSending ? 'Отправка...' : 'Отправить'}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
